import { render, staticRenderFns } from "./CardLimitMixin.vue?vue&type=template&id=ff30ccf4&"
import script from "./CardLimitMixin.vue?vue&type=script&lang=js&"
export * from "./CardLimitMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports